import type { StaticFileIdFormat } from '../../../model/model.ts'

export const frMrgaStaticFilesIds_v1_0_0 = [
  'fr-mrga-general-terms-v1_0_0',
  'fr-mrga-ipid-v1_0_0',
  'fr-mrga-legal-protection-terms-v1_0_0',
  'fr-mrga-legal-protection-ipid-v1_0_0',
] as const satisfies readonly StaticFileIdFormat<'fr-mrga'>[]
